import React from 'react';
import {Progress, Button, Modal, ModalHeader, ModalFooter, ModalBody,Dropdown,DropdownMenu , Alert, DropdownToggle,DropdownItem,Form,FormGroup, FormText,Label, Input  } from 'reactstrap';

class DocumentLinkExpired extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
         <div>
            <Modal isOpen={this.props.visible} toggle={this.props.toggle}>
                <ModalHeader>Share Link Expired</ModalHeader>
                    <ModalBody>
                        <ModalBody>
                            This share link has expired, please generate a new one to download the file
                        </ModalBody>
                    </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
         </div>
        )
    }
}

export default (DocumentLinkExpired);